import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import Client from './client'
import Loading from '../images/loading.png'

  class Clients extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
          clients: [],
          view: 'clients',
          client_id: '',
          loading: true
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.ViewClient = (user_id) => {
        this.setState({view: 'client', client_id: user_id})
      }

      this.CheckClients = () => {
        var clients = this.state.clients
        var clients_map = clients.map((client, index) => {
          return<Row style={{width: '150px', height: '200px', margin: '15px'}}>
            <Col>
              <Button onClick={() => this.ViewClient(client._id.$oid)} style={{backgroundColor: 'inherit', color: 'inherit', border: 'none'}}>
                <img src={Backend_Url + 'media/' + client.image} style={{width: '100%'}}/>
                <br/>
                <h6 style={{fontWeight: 'bold'}}>
                  {client.firstname} {client.lastname}
                </h6>
                <p>
                {client.bio.substring(0, 15)}...
                </p>
              </Button>
            </Col>
          </Row>
        })

        if(clients.length == 0){
          return<div>
            <br/>
            <Row>
                <Col>
                    <h5 style={{marginTop: '60px', textAlign: 'center', marginBottom: '400px'}}>
                        You don't have any clients yet.
                    </h5>
                </Col>
            </Row>
          </div>
        }else{
          return<Row>
            {clients_map}
          </Row>
        }
      }

    }

    componentDidMount() {
      window.scrollTo(0, 0)
      
      const { cookies } = this.props;
      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      axios.post(Backend_Url + 'allClients', data)
      .then((res) => {
          let result = res.data
            this.setState({clients: result, loading: false})
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      if(this.state.loading){
        return (
          <Row>
              <Helmet>
                <title>CLIENTS - ONFIT</title>
                {/* <meta name="description" content="" /> */}
              </Helmet>
              <div style={{minHeight: '900px', backgroundColor: '#ffffff', opacity: 0.9}}>
                <br/><br/>
                <img src={Loading} style={{width: '30%'}}/>
                <br/><br/><br/>
              </div>
          </Row>
        );
      }

      if(this.state.view == 'client'){
        return<Client user_id={this.state.client_id}/>
      }

      return (
        <Row>
            <Helmet>
              <title>TRAINER CLIENTS - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Clients
              </h4>
              <br/>
              <Container>
                <this.CheckClients/>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Clients);